import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request,AuthRequest } from '../services/data-service';
import { Api } from '../services/api';

const Stages = {
	Upload:"Upload", Ready:"Ready",
	InProcess:"InProcess", Done:"Done"
}

@inject(DataService, Api, Router)
export class MachineDatasetNew {
	/** Component methods **/
	constructor(ds, api, router){
		this.ds			= ds;
		this.api		= api;
		this.router 	= router;
		this.file		= "";

		this.Stages		= Stages;
		this.stage		= Stages.Ready;
	}

	/** Custom methods **/

	activate(params){
		this.id = params.id;
		this.uid = params.uid;
		// console.log("parmas => ", params);
	}

	attached(){
		// Load user datasets
		window.setTimeout( () => { this.init(); }, 300);
	}

	init(){

		let machine = this.ds.app_data.machine;
		if(machine){
			this.machine = machine;

		}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
			})
		}

	}



	formatBytes(bytes, decimals = 2) {
		if (!+bytes) return '0 Bytes'
		const k = 1024
		const dm = decimals < 0 ? 0 : decimals
		const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		const i = Math.floor(Math.log(bytes) / Math.log(k))
		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
	}

	/** MARK:API Calls
		============================================
	 **/


	requestStorageQuota(fileSize){
		// Subscription token
		let subsToken		= this.ds.user.subs;
		let uid				= this.ds.user.uid; // From ds
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-storage-token", "POST");

		let body			= { uid: uid, size:fileSize };
		request.body		= JSON.stringify(body);
		// Add subscription header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}


	
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}
	
	updateMachine(machine, fields){
		let request = new Request("/api/v2/machines/", "PUT");
		let body		= { machine: machine, fields:fields };
		request.body	= JSON.stringify(body);
		return this.api.put(request);
	}

	handleResponseMachineUpdate(response){
		//console.log("update response => ", response);
	}

	/** Action methods **/
	uploadFile(){
		return new Promise(resolve => {

		// Respons dataset
		let response_dataset;
		
		let dataset_document = {
			name	: this.file.name,
			size	: this.file.size,
			uid		: this.ds.user.uid,
			type	: "source"
		};

		let request	= new Request("/api/v2/datasets/", "POST");
		// Add AccesToken Auth Header
		request.headers["Authorization"] = "Bearer " + this.accessToken;

		this.readFile(this.file).then(f => {
			if(f){
				let file		= f;
				let body		= { "dataset": dataset_document, "file":file };
				request.body 	= JSON.stringify(body);
				return this.api.post(request);
			}
			else{
				return new Promise(resolve => { resolve(400)});
			}
		})
		.then(response => {
			// Perform summary
			// Dataset id
			let id = response.data._id
			let req 	= new Request( "/api/v2/summary/","POST");
			let body 	= { dataset:response.data };
			req.body 	= JSON.stringify(body)
			// Setup response dataset
			response_dataset = response.data;

			// Update response machine ( machine, fields)
			// dataset_info = { name, size }
			let dataset_info = { name:dataset_document.name, size:dataset_document.size}
			this.updateMachine(this.machine, { dataset: response_dataset.file_name, dataset_info:dataset_info } )
			// Update local machine
			this.ds.app_data.machine.dataset = response_dataset.file_name;
			this.ds.app_data.datset = response.data;
			// POST summary
			return this.api.post(req);
		})
		.then(res => {
			//console.log("summary =>", res);
			// Update Machine
			//this.router.navigateToRoute("models.settings", { id:this.id });
			resolve(res);
		}).catch( (e) => {console.log("Invalid request => ", e);});

		})
		.catch( (e) => { console.log("faild upload => ", e);});

	}

	readFile(file){
		if(file){
			let fr = new FileReader();
			// Read as URL
			// Add event listener
			fr.addEventListener('loadstart', this.frChangeStatus('Start loading'));
			fr.addEventListener('load', this.frChangeStatus('Loaded'));
			fr.addEventListener('loadend', this.frLoaded);
			fr.addEventListener('progress', this.frSetProgress);
			fr.addEventListener('error', this.frErrorHandler);
			fr.addEventListener('abort', this.frChangeStatus('Interrupted'));

			return new Promise(resolve => {
				fr.readAsDataURL(file);
				fr.onload = () => { resolve(fr.result);};
			});
		}
		else{
			return new Promise(resolve => { resolve(null);});
		}
	}
	onSelectFile($event){this.file = $event.target.files[0];}
	frChangeStatus(status){console.log("status: ", status);}

	frLoaded(e){
		let file = e.target
		this.fileStream = file.result;
	}
	frSetProgress(e){}
	frErrorHandler(e){}



	// Next button action(submit)

	next(){
		// Change stage status
		this.stage = Stages.InProcess;
		// Get Resources access Token
		let fileSize = this.file.size // in bytes
		this.requestStorageQuota(fileSize).then(responseQuota => {
			let status = responseQuota.status;
			if(status === 200){
				// Operational Access Token OperAccesToken
				let accessToken 	= responseQuota.data.oper_token; 
				this.accessToken 	= accessToken;
				// Continue with operation
				return this.uploadFile();
			}else{
				return status;
			}
		})
		.then(res => {
			// console.log("res => ", res);
			// Remove datasets to force reload
			this.ds.app_data.datasets = null;
			//if(res.status === 200){ this.router.navigateToRoute('datasets', { uid:this.id }) }

			if(res.status === 200){this.router.navigateToRoute("models.settings", { id:this.id });}
			else{
				window.setTimeout( () => {this.stage = Stages.Ready}, 450)
 
			}
		});
	}
	


	_next(){
		this.uploadFile()
		/*
		this.uploadFile().then(response => {
			window.setTimeout( () => { this.router.navigateToRoute("models.settings", { id:this.id }); }, 1000);
		});
		*/
		/*
		window.setTimeout( () => {
			this.router.navigateToRoute("models.settings", { id:this.id });
		}, 1000);
		*/
		
	}
}
